import styled from 'styled-components'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import theme from '../theme'
import FormLabel from '../FormLabel'

export class FormField extends Component {
  constructor() {
    super()
    this.formFieldId = generateId()
  }
  getChildContext() {
    return {
      formFieldId: this.formFieldId
    }
  }

  renderRequired = () => {
    if (this.props.required) {
      return <StyledRequired>*</StyledRequired>
    }
  }

  render() {
    const { formLayout = 'basic', labelWidth } = this.context
    const {
      children,
      className,
      cropLabel,
      htmlFor,
      label,
      offsetAbsentLabel,
      required,
      ...otherProps
    } = this.props

    // elements
    const componentLabel = label ? (
      <FormLabel htmlFor={htmlFor} cropText={cropLabel} required={required}>
        {label} {this.renderRequired()}
      </FormLabel>
    ) : null

    return (
      <StyledFormField
        formLayout={formLayout}
        offsetAbsentLabel={offsetAbsentLabel}
        labelWidth={labelWidth}
        className={className}
        htmlFor={htmlFor}
        {...otherProps}
      >
        {componentLabel}
        {children}
      </StyledFormField>
    )
  }
}

FormField.contextTypes = {
  formLayout: PropTypes.oneOf(['basic', 'horizontal', 'inline']),
  labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
FormField.childContextTypes = {
  formFieldId: PropTypes.string
}
FormField.propTypes = {
  children: PropTypes.node,
  cropLabel: PropTypes.bool,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  offsetAbsentLabel: PropTypes.bool
}

function generateId() {
  return Math.random().toString(36).substr(2, 9)
}

const StyledFormField = styled.div`
  margin-bottom: 1em;
  position: relative;

  ${(props) =>
    props.formLayout === 'horizontal' &&
    `
    @media (min-width: ${theme.breakpoint.tabletLandscapeMin}) {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
  `}

  ${(props) =>
    props.offsetAbsentLabel &&
    `
    padding-left: ${props.labelWidth || theme.form.label.width};
  `}

  ${(props) =>
    props.formLayout === 'inline' &&
    `
    display: inline-block;
    padding-left: 0.25em;
    padding-right: 0.25em;
    vertical-align: top;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  `}
`

const StyledRequired = styled.span`
  color: ${theme.color.info};
`

export default FormField
